subscribe(PUB_SUB_EVENTS.variantChange, (data) => {
  const pbxVariantChangeEvent = new CustomEvent("pbx:variant:change", {
    detail: {
      variantId: data.variantId,
    },
  });
  document.dispatchEvent(pbxVariantChangeEvent);
});

// 2. Obsługa kliknięcia w 'variantes custom'
document.addEventListener("DOMContentLoaded", function () {
  const variantItems = document.querySelectorAll('.variant-item');

  variantItems.forEach(item => {
    item.addEventListener('click', function () {
      const variantId = parseInt(this.dataset.variantId);
      const variantTitle = this.dataset.variantName;
      const variantImage = this.querySelector('img')?.getAttribute('src');

      if (!variantId) return;

      // Zamknij modal
      const modal = this.closest('.variant-modal-overlay');
      if (modal) modal.style.display = 'none';

      // Zaktualizuj tekst i obraz wybranego wariantu
      const sectionId = modal?.id.replace('variantModal-', '');
      if (sectionId) {
        const selectedName = document.getElementById(`selectedVariantName-${sectionId}`);
        const selectedImage = document.getElementById(`selectedVariantImage-${sectionId}`);

        if (selectedName) selectedName.textContent = variantTitle;
        if (selectedImage && variantImage) selectedImage.setAttribute('src', variantImage);
      }

      // Wyślij event pbx:variant:change
      const pbxVariantChangeEvent = new CustomEvent("pbx:variant:change", {
        detail: {
          variantId: variantId,
        },
      });

      document.dispatchEvent(pbxVariantChangeEvent);
    });
  });
});




